import React, { useEffect } from 'react'
import Icon from 'blocks.simple/icon/icon'
import { IEventDetailsProps } from './EventDetails-types'
import { styles } from './EventDetails-styles'

export const EventDetails = ({ title, backLabel, groups, onBack }: IEventDetailsProps) => {
    useEffect(() => {
        const previousOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'

        return () => {
            document.body.style.overflow = previousOverflow
        }
    }, [])

    return (
        <main className={styles.wrapper} aria-labelledby="event-details-title">
            <div className={styles.content}>
                <button type="button" className={styles.backButton} onClick={onBack}>
                    <span className={styles.backIcon} aria-hidden="true">
                        ‹
                    </span>
                    <span>{backLabel}</span>
                </button>
                <h1 id="event-details-title" className={styles.title}>
                    {title}
                </h1>
                <div>
                    {groups.map((group, groupIndex) => (
                        <section className={styles.group} key={`event-details-group-${groupIndex}`}>
                            {group.map((field, fieldIndex) => (
                                <div className={styles.field} key={`${field.label}-${fieldIndex}`}>
                                    <div className={styles.label}>{field.label}</div>
                                    {field.action ? (
                                        <button
                                            type="button"
                                            className={styles.actionButton}
                                            onClick={field.action.onClick}
                                        >
                                            <Icon type="view" size={14} className={styles.actionIcon} />
                                            {field.action.label}
                                        </button>
                                    ) : (
                                        <div className={styles.value}>
                                            {field.accentColor && (
                                                <span
                                                    className={styles.accent}
                                                    style={{ backgroundColor: field.accentColor }}
                                                />
                                            )}
                                            {field.value === null || field.value === undefined || field.value === ''
                                                ? '—'
                                                : field.value}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </section>
                    ))}
                </div>
            </div>
        </main>
    )
}
